import IconButton from '@/global/components/Button/IconButton'
import { Link } from '@/global/components/Link'
import Menu from '@/global/components/MenuV2'
import { AlertTriangleIcon } from 'lucide-react'

export default function IconeCompetenciaFutura() {
    return (
        <Menu.Root arrow>
            <Menu.Trigger>
                <IconButton>
                    <AlertTriangleIcon className="text-warning" />
                </IconButton>
            </Menu.Trigger>
            <Menu.Popover className="p-4 w-max max-w-sm">
                A ausência foi lançada em uma competência futura. Verifique se a
                <Link href="/manutencao-ponto/fechamento-competencia">
                    &nbsp;competência atual&nbsp;
                </Link>
                está correta antes de prosseguir.
            </Menu.Popover>
        </Menu.Root>
    )
}
